import { useMutation } from '@tanstack/react-query';
import { api } from '@/api';
import { NewLogisticProvidersFormBody, PatchLogisticProvidersFormBody } from '@/api/apis/facilities';
import { queryClient } from '@/queries';
import { txCenterProvidersQueries } from '@/queries/txcenter-providers';
import { txCenterProvidersQueryKeys } from '@/queries/txcenter-providers/txcenter-providers.keys';

type RemoveLogisticProviderMutationVars = {
  id: string;
};

export const useRemoveTXCenterProviderMutation = () => {
  return useMutation({
    mutationFn: (variables: RemoveLogisticProviderMutationVars) =>
      api.txcenterprovider.removeTXCenterProviderById(variables.id),
    meta: {
      invalidates: [txCenterProvidersQueryKeys.getList()],
    },
  });
};

export const useCreateTXCenterProviderMutation = () => {
  return useMutation({
    mutationFn: (variables: NewLogisticProvidersFormBody & { id: string }) =>
      api.txcenterprovider.createTXCenterProvider(variables),
    meta: {
      invalidates: [txCenterProvidersQueryKeys.getList()],
    },
    onSuccess: (data, variables) => {
      queryClient.setQueryData(txCenterProvidersQueries.item(variables.id).queryKey, data);
    },
  });
};

export const useUpdateTXCenterProviderMutation = () => {
  return useMutation({
    mutationFn: (variables: PatchLogisticProvidersFormBody & { id: string }) =>
      api.txcenterprovider.updateTXCenterProviderById(variables),
    meta: {
      invalidates: [txCenterProvidersQueryKeys.getList()],
    },
    onSuccess: (data, variables) => {
      queryClient.setQueryData(txCenterProvidersQueries.item(variables.id).queryKey, data);
    },
  });
};
